<mat-paginator [showFirstLastButtons]="showFirstLastButtons" [attr.aria-label]="ariaLabel" [length]="length"
               [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageChange.emit($event)"
               class="transparent-paginator"></mat-paginator>
